export default "__VITE_ASSET__4c241cc7__"